import {t, UserFacingCatalogueError} from '../utils/catalogueUi';

/**
 * A batch with a pricelist version whose response was lost, and whose read-back failed too (spec
 * 7.5): the batch may or may not be written. Sending it again could write it twice, so the group
 * keeps it and Confirm waits until a later read-back tells the outcome.
 */
export class PricedItemBatchOutcomeUnknown extends UserFacingCatalogueError {
  /** The message, also for the bar of a group that holds such a batch. */
  static text = () =>
    t(
      'entity.newVehicle.catalogue.itemGroup.outcomeUnknown',
      'We could not confirm whether the changes were saved. Check the pricelist version history, then review the group again.'
    );

  constructor() {
    super(PricedItemBatchOutcomeUnknown.text());
    this.name = 'PricedItemBatchOutcomeUnknown';
  }
}
